import { all } from 'redux-saga/effects';
import nannyBookings from './nannyBookings';

export const nannyBookingsSaga = function* root() {
  yield all([nannyBookings()]);
};
